// extracted by mini-css-extract-plugin
module.exports = {"root":"_1O9NU","text":"_2dL39","buttonsContainer":"_3NrYD","button":"_19_fi"};